import { ChevronDown } from '@components/icons'
import ClickOutside from '@lib/click-outside'
import cn from 'clsx'
import { useState } from 'react'
import s from './SelectDropDown.module.css'

interface option {
  name: string
  value: string
  availableForSale?: boolean
  price?: string
  quanityAvailable?: number
  listPrice?: string
}

interface Props {
  options: option[]
  arialLabel?: string
  className?: string
  disabled?: boolean
  selectedOption: option
  handleOptionSelection: (selected: option) => void
  placeholder?: string
  productDropdown?: boolean
}
const SelectDropDown = ({
  options,
  selectedOption,
  arialLabel,
  className,
  handleOptionSelection,
  disabled = false,
  placeholder,
  productDropdown,
}: Props) => {
  const [display, setDisplay] = useState(false)

  const handleClickOutSide = () => setDisplay(false)
  const handleButtonClick = () => {
    setDisplay(!display)
  }

  return (
    <>
      <ClickOutside active={display} onClick={handleClickOutSide}>
        <div
          className={cn(
            'label dropdown relative flex-1 text-brand-dark-grey',
            className
          )}
        >
          <button
            className={cn(
              'flex w-full items-center justify-between rounded border py-3 px-4',
              { 'bg-white': !disabled },
              { 'border-ui-grey-25': disabled },
              { 'body-1 min-h-18': productDropdown }
            )}
            onClick={handleButtonClick}
            arial-label={arialLabel || 'Dropdown'}
            disabled={disabled || options.length === 0}
            type="button"
          >
            <div className="body flex flex-col ">
              <span
                className={cn('flex justify-start text-dark-grey', {
                  'opacity-50': disabled || options.length === 0,
                  'body-1-bold': productDropdown && selectedOption?.name,
                })}
              >
                {selectedOption?.name
                  ? selectedOption.name
                  : placeholder
                  ? placeholder
                  : 'Please select'}
              </span>{' '}
              {selectedOption?.price ? (
                <span className="body-2 text-left">
                  {selectedOption?.price}
                </span>
              ) : null}
            </div>

            <div className="flex items-center">
              <span className="flex items-center">
                <ChevronDown
                  width={12}
                  height={6.5}
                  className={cn(s.icon, { [s.active]: display })}
                />
              </span>
            </div>
          </button>
          <ul
            className={cn(
              'options absolute z-20 max-h-50 w-full overflow-y-auto rounded shadow-magical scrollbar-hide',
              {
                'flex flex-col': display,
                hidden: !display,
              }
            )}
          >
            {options
              .filter((o) => o.name !== selectedOption.name)
              .map((option, index) => {
                const availableForSale = option.availableForSale
                const handleSelection = () => {
                  if (productDropdown && !availableForSale) return
                  handleOptionSelection(option)
                  setDisplay(false)
                }
                return (
                  <li
                    key={`${option.value}-${index}`}
                    onClick={handleSelection}
                    className={cn(
                      'flex w-full cursor-pointer flex-col  border-t-0 bg-white p-2 pl-4',
                      {
                        'body-1-bold min-h-18 justify-center': productDropdown,
                      },
                      {
                        'cursor-not-allowed bg-ui-light-grey text-black text-opacity-40':
                          productDropdown && !availableForSale,
                      }
                    )}
                  >
                    {option.name}
                    {`${
                      productDropdown && !availableForSale
                        ? ' (Out of stock)'
                        : ''
                    }`}
                    <label>
                      {option?.listPrice &&
                      option?.listPrice > option?.price! ? (
                        <del className="body-2 mr-1">{option?.listPrice}</del>
                      ) : null}
                      {option?.price && (
                        <span className="body-2">{option?.price}</span>
                      )}
                    </label>
                  </li>
                )
              })}
          </ul>
        </div>
      </ClickOutside>
    </>
  )
}

export default SelectDropDown
